import { h } from "hyperapp";

export const Portifolios = ({
  translations,
  actions: { fetchPortifolios, setPortifolio },
  section,
  state: { portifolios, portifolioID, clientID, disabled, loading },
}): JSX.Element => {
  return (
    <div class="col-12 col-md-4 col-lg-12 d-md-inline-block mb-3 p-0">
      <label
        style="margin-bottom:0;line-height:0;color:#666666;font-weight:bold"
        for="timespan"
      >
        {translations["fromPortifolio"]}
      </label>
      <select
        class="custom-select form-control"
        disabled={loading || disabled}
        id="timespan"
        onblur={event =>
          setPortifolio({ portifolioID: event.target.value, section })
        }
        oncreate={() => fetchPortifolios({ clientID })}
      >
        <option selected value="any">
          {translations["allPortifolios"]}
        </option>
        {portifolios
          .sort(portifolio => portifolio.name)
          .map(portifolio => {
            return (
              <option
                selected={portifolio.id === portifolioID}
                value={portifolio.id}
              >
                {portifolio.name}
              </option>
            );
          })}
      </select>
    </div>
  );
};
